import React, { useState, useEffect } from 'react';
import { Button, Row, Col, Modal } from 'antd';
import ProfileData from '../ProfileData';
import NewMatch from '../NewMatch';
import Visitors from '../Visitors';
import Liked from '../Liked';
import AIData from '../AIList/';
import HeartIcon from '@/common/assets/images/fullHeart.svg';
import HeartOut from '@/common/assets/images/heart.svg';

import styles from '../index.module.less';
import { UserOutlined } from '@ant-design/icons';
import { MdOutlineWorkOutline } from 'react-icons/md';
import { FaGraduationCap, FaMoneyCheckAlt } from 'react-icons/fa';
import { IoLocationOutline } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
// import { useDispatch } from 'react-redux';
import AiLove from '../../../../common/assets/images/AILoveLoader.gif';
// import { likeProfile, unlikeProfile } from '../../redux/slice';
import AIlogo from '@/common/assets/images/AILogo.svg';

const List = (
  // { handlegetAIData, list_AIdata, aiacceptedLoading }
  {
    user_data,
    list_data,
    activeTab,
    // setActiveTab,
    list_pagination,
    handlegetAIData,
    list_AIdata,
    aiacceptedLoading,
    onSubmit,
    onProfileAction
  }
) => {
  // console.log('list_AIdata', list_AIdata?.rows);
  // console.log('aiacceptedLoading', aiacceptedLoading);
  // console.log('list_data', list_data);

  useEffect(() => {
    document.title = 'Dashboard - Samskruti Matrimony';
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedMatch, setSelectedMatch] = useState(null);
  const showMatchModal = (match) => {
    setSelectedMatch(match);
    setIsModalVisible(true);
  };
  // console.log(selectedMatch, 'selected Match list ');

  const closeModal = () => setIsModalVisible(false);

  const [showDetails, setShowDetails] = useState(true);
  const [likedProfiles, setLikedProfiles] = useState({});
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();
  // const dispatch = useDispatch();

  const handleButtonClick = () => {
    setShowDetails(false);
    handlegetAIData();
  };

  const handleViewProfile = (id) => {
    // console.log('Calling view API with ID:', id);
    navigate(`/profileview/${id}`);
  };

  const handleShortList = (profileId) => {
    // console.log('Short list', profileId);
    onSubmit({ profile_id: profileId, action: 'short_profile' });
  };

  const handleSendRequest = (profileId) => {
    onSubmit({ profile_id: profileId, action: 'send_request' });
  };

  // const handleLikeClick = async (e, profileId) => {
  //   e.stopPropagation(); // Prevents triggering parent onClick
  //   // console.log('Heart clicked for profile ID:', profileId);
  //   setLikedProfiles((prev) => ({
  //     ...prev,
  //     [profileId]: !prev[profileId] // Toggle like state
  //   }));

  //   const newLikedStatus = !likedProfiles[profileId];
  //   let payload = { profile_id: profileId };

  //   try {
  //     // console.log('Submitting like/unlike:', payload);
  //     const response = newLikedStatus
  //       ? await dispatch(likeProfile(payload)).unwrap()
  //       : await dispatch(unlikeProfile(payload)).unwrap();

  //     if (response?.success) {
  //       // setLikedLoading(false);
  //       message.success(
  //         response.message || (newLikedStatus ? 'Liked!' : 'Unliked!')
  //       );
  //     } else {
  //       message.error('Failed to update like status');
  //     }
  //   } catch (error) {
  //     console.error('Error submitting like/unlike:', error);
  //     message.error(error?.message || 'Failed to update like status.');
  //   }
  // };

  // likedProfiles, setLikedProfiles

  const renderedTabContent = () => {
    switch (activeTab) {
      case '1':
        return (
          <ProfileData
            list_data={list_data}
            // paginatedData={paginatedData}
            // currentPage={currentPage}
            // pageSize={pageSize}
            // totalItems={list_pagination?.total_items}
            // totalItems={list_pagination?.total_records || list_data.length}
            totalItems={list_pagination?.total_records || 9}
            // handlePageChange={handlePageChange}
          />
        );
      case '2':
        return <NewMatch />;
      case '3':
        return <Visitors />;
      case '4':
        return (
          <Liked
            list_data={list_data}
            // paginatedData={paginatedData}
            // currentPage={currentPage}
            // pageSize={pageSize}
            // totalItems={list_pagination?.total_items}
            // totalItems={list_pagination?.total_records || list_data.length}
            totalItems={list_pagination?.total_records || 9}
            // handlePageChange={handlePageChange}
          />
        );
      case '5':
        return (
          <AIData
            handlegetAIData={handlegetAIData}
            list_AIdata={list_AIdata}
            // list_data={list_data}
            aiacceptedLoading={aiacceptedLoading}
          />
        );

      default:
        return null;
    }
  };

  const transformedData = list_AIdata?.rows?.flatMap((item) => {
    return item.Profiles.map((profile) => ({
      pic:
        profile.ProfileImages.length > 0
          ? profile.ProfileImages[0].objectKey
          : '',
      // code: item.user_name || '',
      code: item?.profile_unique_id || '',
      name: profile?.profile_name || '',
      dob: profile?.calculated_age ? `${profile?.calculated_age} yrs` : '',
      // height: `${profile.height_ft || ''}' ${profile.height_in || ''}"`,
      height: profile?.height_cms ? `${profile.height_cms} cm` : '',
      marriedStatus: profile?.MaritalStatus?.marital_status, // Add if available in your data
      address: profile.City?.city || '',
      occupation: profile.employed_in || '',
      education:
        profile.ProfileEducations.map(
          (edu) => edu.HigherEducation.education
        ).join(', ') || '',
      // income: profile.annual_income || '',
      income: profile.annual_income
        ? Number(profile.annual_income).toLocaleString()
        : '',
      isNew: item?.is_new, // Assuming a default value
      isFavourite: profile.is_favourite, // Assuming a default value
      id: item.id,
      profile_id: profile.id,
      cScore: profile.compatibilityScore || '',
      r1: profile.reasons[0] || '',
      r2: profile.reasons[1] || '',
      r3: profile.reasons[2] || '',
      userImage:
        profile.userImages.length > 0 ? profile.userImages[0].objectKey : ''
    }));
  });

  // useEffect(() => {
  //   if (list_AIdata?.rows) {
  //     const updatedLikedProfiles = {};

  //     let hasFavorites = false; // Flag to check if there is any favorite profile

  //     list_AIdata.rows.forEach((item) => {
  //       item.Profiles.forEach((profile) => {
  //         if (profile.is_favourite) {
  //           updatedLikedProfiles[profile.id] = true;
  //           hasFavorites = true; // Mark that at least one profile is a favorite
  //         }
  //       });
  //     });

  //     setLikedProfiles((prev) => {
  //       // If no favorites found, set it to false
  //       if (!hasFavorites) return false;

  //       // Only update state if there is a change to prevent unnecessary re-renders
  //       if (JSON.stringify(prev) !== JSON.stringify(updatedLikedProfiles)) {
  //         return updatedLikedProfiles;
  //       }
  //       return prev;
  //     });
  //   }
  // }, [list_AIdata]);

  useEffect(() => {
    if (list_AIdata?.rows) {
      const updatedLikedProfiles = {};

      list_AIdata.rows.forEach((item) => {
        item.Profiles.forEach((profile) => {
          if (profile.is_favourite) {
            updatedLikedProfiles[profile.id] = true;
          }
        });
      });

      setLikedProfiles(updatedLikedProfiles); // Directly set new state
    }
  }, [list_AIdata]);

  console.log('setLikedProfiles', likedProfiles);

  // const handleLikeClick = (e, profileId, sourceType) => {
  //   e.stopPropagation(); // Prevents triggering parent onClick
  //   const newLikedStatus = !likedProfiles;

  //   setLikedProfiles(newLikedStatus);
  //   console.log('profileId:', profileId, 'Liked:', newLikedStatus);

  //   // Call the parent function and pass profileId & actionType
  //   onProfileAction(profileId, newLikedStatus ? 'like' : 'unlike', sourceType);
  // };

  const handleLikeClick = (e, profileId, sourceType) => {
    e.stopPropagation(); // Prevents triggering parent onClick

    setLikedProfiles((prev) => ({
      ...prev,
      [profileId]: !prev[profileId] // Toggle liked status for the profile
    }));

    // console.log('profileId:', profileId, 'Liked:', !likedProfiles[profileId]);

    // Call the parent function and pass profileId & actionType
    onProfileAction(
      profileId,
      !likedProfiles[profileId] ? 'like' : 'unlike',
      sourceType
    );
  };

  return (
    <>
      <br />
      <br />

      {showDetails ? (
        <div className={styles.aidetails}>
          <h1>Discover connections made for you!</h1>
          <h5>Your best match is just a click away!</h5>
          <div className={styles.findMatchbutton}>
            <Button
              className={styles.outlinebtn}
              onClick={() => {
                // handlegetAIData();
                handleButtonClick();
              }}
            >
              Find My Match
            </Button>
          </div>
        </div>
      ) : aiacceptedLoading ? (
        <div className={styles.aiLoader}>
          <img src={AiLove} alt="loading" width={'150px'} />
        </div>
      ) : (
        <>
          <div className={styles.searchResult}>
            {transformedData?.map((data, index) => (
              <div key={data.code || index} className={styles.cardOuter1}>
                <div className={styles.cardOutline1}>
                  <div
                    className={styles.cardInner11}
                    style={{
                      cursor: 'pointer'
                    }}
                  >
                    <img
                      src={data.pic}
                      alt={data.name}
                      className={styles.cardImage1}
                    />
                    {(data.isNew || data.isFavourite) && (
                      <div className={styles.cardNew1}>
                        {data.isNew && 'New '}
                        {data.isFavourite && 'Favourite'}
                      </div>
                    )}

                    <div className={styles.cardIcons1}>
                      <>
                        <div
                          className={styles.cardIcons}
                          onMouseEnter={() => setIsHovered(data.profile_id)}
                          onMouseLeave={() => setIsHovered(null)}
                        >
                          <div
                            onClick={(e) =>
                              handleLikeClick(e, data.profile_id, 'aiData')
                            }
                            style={{ cursor: 'pointer' }}
                          >
                            <img
                              src={
                                likedProfiles[data.profile_id] ||
                                isHovered === data.profile_id
                                  ? HeartIcon
                                  : HeartOut
                              }
                              alt="heart"
                            />
                          </div>
                        </div>
                      </>
                    </div>
                  </div>

                  <div className={styles.cardOuter22}>
                    <div className={styles.nametag}>
                      <div
                        className={styles.cardInner22}
                        style={{
                          color: '#d20b0b',
                          backgroundColor: 'transparent'
                        }}
                      >
                        <span className={styles.cardInnerTitle1}>
                          {data?.name}
                        </span>
                        <span className={styles.cardInnerSubTitle1}>
                          {data?.code}
                        </span>
                      </div>
                      <div
                        className={styles.match}
                        onClick={() => showMatchModal(data)}
                      >
                        <img
                          src={AIlogo}
                          alt="AI Logo"
                          className={styles.ailogo}
                        />
                        <span>You are a {data.cScore}/100 Match</span>
                      </div>
                    </div>
                    <div
                      className={styles.cardInnerDetails1}
                      style={{
                        color: '#d20b0b',
                        background: 'transparent'
                      }}
                    >
                      <span className={styles.cardDetails1}>
                        <UserOutlined />
                        {[data.dob, data.height, data.marriedStatus]
                          .filter(Boolean)
                          .join(' / ')}
                      </span>
                      <span className={styles.cardDetails1}>
                        <FaGraduationCap style={{ paddingTop: '3px' }} />{' '}
                        {data.education}
                      </span>
                      <span className={styles.cardDetails1}>
                        <MdOutlineWorkOutline style={{ paddingTop: '3px' }} />{' '}
                        {data.occupation}
                      </span>

                      <span className={styles.cardDetails1}>
                        <FaMoneyCheckAlt style={{ paddingTop: '3px' }} />{' '}
                        {data.income ? `Rs ${data.income}` : ''}
                      </span>
                      <span className={styles.cardDetails1}>
                        <IoLocationOutline style={{ paddingTop: '3px' }} />{' '}
                        {data.address}
                      </span>

                      <div className={styles.searchDiv}>
                        <button
                          className={styles.searchBtn}
                          onClick={() => handleViewProfile(data.id)}
                        >
                          View Profile
                        </button>
                        <button
                          className={styles.searchBtn}
                          onClick={() => handleSendRequest(data.profile_id)}
                        >
                          Send Request
                        </button>
                        <button
                          className={styles.searchBtn}
                          onClick={() => handleShortList(data.profile_id)}
                        >
                          ShortList Profile
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <Modal
            visible={isModalVisible}
            onCancel={closeModal}
            footer={null}
            centered
            style={{ background: 'rgba(250, 241, 217, 1)' }}
          >
            {selectedMatch && (
              <div>
                <div className={styles.modalFirst}>
                  <img
                    src={selectedMatch.userImage}
                    alt={selectedMatch.name}
                    className={styles.modalImage}
                  />
                  <div style={{ padding: '20px 8px' }}>
                    <div className={styles.youMatch}>You Match</div>
                    <div className={styles.prefer}>
                      {selectedMatch.cScore}/100 of his Prefernces
                    </div>
                  </div>
                  <img
                    src={selectedMatch.pic}
                    alt={selectedMatch.name}
                    className={styles.modalImage}
                  />
                </div>

                <Row className={styles.moredetails}>
                  <Col>
                    <h5 className={styles.h5details}>You share common</h5>
                    <ul>
                      <li>
                        <h5>{selectedMatch.r1}</h5>
                      </li>
                      <li>
                        <h5> {selectedMatch.r2}</h5>
                      </li>
                      <li>
                        <h5> {selectedMatch.r3}</h5>
                      </li>
                    </ul>
                  </Col>
                </Row>
              </div>
            )}
          </Modal>
          <br />
          <Row className={styles.moredetails}>
            <Col>
              <h2>MEET YOUR MATCHES !</h2>
              <h5 className={styles.h5details}>You share common</h5>
              <ul>
                <li>
                  <h5>interest,</h5>
                </li>
                <li>
                  <h5> relationship goals, and</h5>
                </li>
                <li>
                  <h5> a great compatibility score with them</h5>
                </li>
              </ul>
            </Col>
          </Row>
          <Row className={styles.moredetails1}>
            <h5>Your best match might be just one more try away! </h5>
            <Button
              className={styles.refreshbtn}
              onClick={() => {
                // handlegetAIData();
                handleButtonClick();
              }}
            >
              Refresh My Match
            </Button>
          </Row>
          {/* <Button
            className={styles.outlinebtn}
            onClick={() => {
              handlegetAIData();
              handleButtonClick();
            }}
          >
            Find My Match
          </Button> */}
        </>
      )}
      <br />
      <br />
      {user_data?.is_subscribed && renderedTabContent()}
    </>
  );
};

export default List;
